import React from 'react';
import Modal from './ModalConversion';

export const SyncConfirmationModal = ({ isOpen, onClose, onConfirm, syncType, selectedChannel }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="p-3">
                <h3 className="mb-4 text-white">Confirmar Sincronización</h3>

                <div className="mb-3 p-3 bg-dark rounded border border-secondary text-white">
                    <p>
                        {syncType === 'partial' ? (
                            <>
                                <strong>Sincronización Parcial</strong>
                                <br />
                                Se sincronizarán solo los títulos con notificaciones pendientes del canal <strong>{selectedChannel}</strong>.
                            </>
                        ) : (
                            <>
                                <strong>Sincronización Completa</strong>
                                <br />
                                Se sincronizarán <strong>TODOS</strong> los títulos activos del canal <strong>{selectedChannel}</strong>.
                                <br />
                                <br />
                                <span className="text-warning">⚠️ Esta operación puede tardar varios minutos.</span>
                            </>
                        )}
                    </p>
                    <p className="mb-0">¿Deseas continuar?</p>
                </div>

                <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top border-secondary">
                    <button type="button" className="btn btn-secondary px-4" onClick={onClose}>
                        Cancelar
                    </button>
                    <button type="button" className="btn btn-success px-4" onClick={onConfirm}>
                        Confirmar
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default SyncConfirmationModal;
